export default __webpack_public_path__ + "static/media/back-to-start-pagination.951e08aa.svg";